/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {Table, Input, Checkbox, Button, Select, DatePicker, Radio, Popover, Pagination, Modal} from "antd";
import Share from "./components/Share";


export default class ShareWithMe extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
    }

    render() {
        return (
            <Share  backList={[{name: '分享给我', id: 0}]} url={'shareToList'} type={true}></Share>
        )
    }


}